import { useEffect, useState } from "react";
import { adminAnalytics, euro } from "@/lib/store";

const Bar = ({ label, value, max }) => (
  <div className="flex items-center gap-3">
    <span className="w-40 shrink-0 text-xs text-zinc-400">{label}</span>
    <div className="h-6 flex-1 overflow-hidden rounded-full bg-white/5">
      <div className="flex h-full items-center justify-end rounded-full bg-[#2563EB] px-2 text-[11px] font-semibold text-white"
        style={{ width: `${max ? Math.max(6, Math.round((value / max) * 100)) : 6}%` }}>{value}</div>
    </div>
  </div>
);

export default function Analytics() {
  const [d, setD] = useState(null);
  const [days, setDays] = useState(30);
  useEffect(() => { adminAnalytics(days).then(setD).catch(() => {}); }, [days]);
  if (!d) return <p className="text-zinc-500">Caricamento…</p>;
  const maxF = Math.max(1, ...d.funnel.map((f) => f.value));
  const maxTs = Math.max(1, ...d.timeseries.map((t) => t.visite));
  return (
    <div className="space-y-6" data-testid="analytics-panel">
      <div className="flex items-center gap-2">
        <h3 className="font-mono text-xs uppercase tracking-widest text-zinc-500">Periodo</h3>
        {[7, 30, 90].map((n) => (
          <button key={n} data-testid={`analytics-days-${n}`} onClick={() => setDays(n)}
            className={`rounded-full border px-3 py-1 text-xs ${days === n ? "border-[#2563EB] bg-[#2563EB]/20 text-white" : "border-white/10 text-zinc-300"}`}>{n}g</button>
        ))}
      </div>

      <section className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        <div className="rounded-xl border border-white/10 bg-[#11141A] p-4"><div className="text-2xl font-bold text-white">{euro(d.fatturato_cents)}</div><div className="mt-1 text-xs text-zinc-500">Fatturato (pagato)</div></div>
        <div className="rounded-xl border border-white/10 bg-[#11141A] p-4"><div className="text-2xl font-bold text-white">{d.conversion_rate}%</div><div className="mt-1 text-xs text-zinc-500">Conversione visite → ordini</div></div>
        <div className="rounded-xl border border-white/10 bg-[#11141A] p-4"><div className="text-2xl font-bold text-white">{d.funnel[0]?.value ?? 0}</div><div className="mt-1 text-xs text-zinc-500">Visitatori</div></div>
      </section>

      <section className="rounded-xl border border-white/10 bg-[#11141A] p-4">
        <h3 className="mb-4 font-mono text-xs uppercase tracking-widest text-zinc-500">Funnel (visitatori → ordini)</h3>
        <div className="space-y-2">{d.funnel.map((f) => <Bar key={f.step} label={f.step} value={f.value} max={maxF} />)}</div>
      </section>

      <section className="rounded-xl border border-white/10 bg-[#11141A] p-4">
        <h3 className="mb-4 font-mono text-xs uppercase tracking-widest text-zinc-500">Sorgenti di traffico (UTM)</h3>
        {d.utm.length === 0 ? <p className="text-sm text-zinc-500">Nessun dato di sorgente. Usa link con ?utm_source=… per tracciare le campagne.</p> : (
          <table className="w-full text-sm"><tbody>
            {d.utm.map((u) => <tr key={u.source} data-testid="utm-row" className="border-t border-white/5"><td className="py-1.5 text-zinc-300">{u.source}</td><td className="py-1.5 text-right font-semibold text-white">{u.visits}</td></tr>)}
          </tbody></table>
        )}
      </section>

      <section className="rounded-xl border border-white/10 bg-[#11141A] p-4">
        <h3 className="mb-4 font-mono text-xs uppercase tracking-widest text-zinc-500">Andamento (ultimi giorni)</h3>
        {d.timeseries.length === 0 ? <p className="text-sm text-zinc-500">Nessun dato ancora.</p> : (
          <div className="flex items-end gap-1.5" style={{ height: 120 }}>
            {d.timeseries.map((t) => (
              <div key={t.date} className="flex flex-1 flex-col items-center gap-1" title={`${t.date}: ${t.visite} visite, ${t.ai} AI`}>
                <div className="w-full rounded-t bg-[#2563EB]" style={{ height: `${Math.round((t.visite / maxTs) * 90)}px`, minHeight: 2 }} />
                <span className="text-[9px] text-zinc-600">{t.date.slice(5)}</span>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
